import Socials from "./Socials";
import CompanyLinks from "./CompanyLinks";
import MyAccountLink from "./MyAccountLink";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from 'lucide-react'; // Import Lucide React icons

export default function Footer1() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-4 md:gap-8 lg:grid-cols-5">
          {/* Company Info Section */}
          <div className="col-span-1 md:col-span-2 lg:col-span-2">
            <Link to="/home-9" className="inline-block mb-4">
              <img
                src="/img/loga.png"
                className="h-10 dark:block"
                alt="iForge Logo"
              />
            </Link>
            <p className="text-sm leading-relaxed text-gray-600 dark:text-gray-400 mb-6">
              Learn, create, and sell your innovative ideas through iForge. Powered by{" "}
              <strong className="text-black dark:text-white">iForge.</strong>
            </p>
            <div className="flex space-x-4">
              <Socials />
            </div>
          </div>

          {/* Quick Links Section */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
              Quick Links
            </h3>
            <ul className="space-y-3 text-sm text-gray-600 dark:text-gray-400">
              <CompanyLinks />
            </ul>
          </div>

          {/* Our Models Section */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
              Our Models
            </h3>
            <ul className="space-y-3 text-sm text-gray-600 dark:text-gray-400">
              <MyAccountLink />
            </ul>
          </div>

          {/* Contact Us Section */}
          <div className="col-span-1 md:col-span-1">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
              Contact Us
            </h3>
            <ul className="space-y-3 text-sm text-gray-600 dark:text-gray-400">
              <li className="flex items-center space-x-2">
                {/* Replaced flag image with emoji */}
                <span className="text-lg">🇰🇪</span>
                <a href="tel:+254117458181" className="hover:text-orange-500 transition-colors flex items-center">
                  <Phone size={16} className="mr-2" /> +254 117 458 181
                </a>
              </li>
              <li className="flex items-center space-x-2">
                {/* Replaced flag image with emoji */}
                <span className="text-lg">🇰🇪</span>
                <a href="tel:+254723706345" className="hover:text-orange-500 transition-colors flex items-center">
                  <Phone size={16} className="mr-2" /> +254 723 706 345
                </a>
              </li>
              <li className="flex items-center space-x-2">
                {/* Replaced flag image with emoji */}
                <span className="text-lg">🇸🇴</span>
                <a href="tel:+252612995802" className="hover:text-orange-500 transition-colors flex items-center">
                   <Phone size={16} className="mr-2" /> +252 61 299 5802
                </a>
              </li>
              <li>
                <a href="mailto:support@iforge.io" className="flex items-center hover:text-orange-500 transition-colors">
                  <Mail size={16} className="mr-2" /> support@iforge.io
                </a>
              </li>
              <li>
                <a
                  href="https://www.google.com/maps?q=Muthaiga+Square,+Nairobi,+Kenya"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start hover:text-orange-500 transition-colors"
                >
                  <MapPin size={16} className="mr-2 mt-0.5" /> Muthaiga Square B301, Nairobi, Kenya
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Separator */}
        <hr className="my-8 border-gray-300 dark:border-gray-700" />

        {/* Copyright & Policy Section */}
        <div className="flex flex-col items-center justify-between space-y-4 sm:flex-row sm:space-y-0">
          <p className="text-sm text-gray-600 dark:text-gray-400">
            © {currentYear} iForge. Made by{" "}
            <a href="https://innovatorsforge.com/" className="font-medium hover:text-orange-500 transition-colors">
              iForge
            </a>
          </p>
          <ul className="flex flex-wrap items-center justify-center space-x-4 sm:justify-start">
            <li>
              <Link to="/terms-n-conditions" className="text-sm text-gray-600 dark:text-gray-400 hover:text-orange-500 transition-colors">
                Terms and Conditions
              </Link>
            </li>
            <li>
              <Link to="/warranty" className="text-sm text-gray-600 dark:text-gray-400 hover:text-orange-500 transition-colors">
                Warranty
              </Link>
            </li>
            <li>
              <a href="/privacy-policy" className="text-sm text-gray-600 dark:text-gray-400 hover:text-orange-500 transition-colors">
                Privacy Policy
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
